import React, { memo } from 'react';
import PropTypes from 'prop-types';

const EmailAndPhone = ( { email, phone } ) => {
	return (
		<div style={{
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}}>
			<a href={ `mailto:${ email }` }>{ email }</a>
			<br />
			<span>{ phone }</span>
		</div>
	);
};

EmailAndPhone.propTypes = {
	email: PropTypes.string.isRequired,
	phone: PropTypes.string.isRequired
};

export default memo( EmailAndPhone );
